module.exports = __webpack_public_path__ + "static/media/classicos_masculino_roupas.3cd4ae73.jpg";